<div class="likert-scale">
  <div class="choices">

    @for (option of scaleOptions; track option) {
      <div
        data-testid="likert-option"
        class="option-box"
        [class.highlighted]="selectedOption === option"
        (click)="select(option)">
        {{option}}
      </div>
    }
  </div>
  <div class="labels">
    <label>{{leftLabel}}</label>

    <label>{{rightLabel}}</label>
  </div>

</div>
